import styled from 'styled-components';
import { theme } from 'styled-tools';

const S = {};

S.Container = styled.div`
  padding: ${theme('spacing.lg')};
`;

export default S;
